import { IReadCommentParams } from "../../repository/props";

export const readComment = (payload?: IReadCommentParams) => ({
  type: "@saga/READ_COMMENT",
  payload,
});
